<template>
  <section>
    <div>
      <p class="title">Custom Application Access Request</p>
      <p class="subTitle">
        Use this page as a single point to manage all personal access to the external systems. Any
        change to your access will need to undergo evaluation and usually takes 1 to 3 days to be
        fully processed.
      </p>
    </div>
    <b-card class="cardStyle mt-4">
      <div class="title text-center">Select a Study ID & a Site:</div>
      <b-form-group class="mb-0">
        <hr class="solid" />
        <b-row class="px-3 mt-4">
          <b-col class="pt-2" cols="5"> Study ID</b-col>
          <b-col cols="7">
            <multiselect
              :options="studyOptions"
              :value="studyId"
              class="rounded-pill"
              placeholder="Select a Study ID"
              @input="updateStudy"
            >
            </multiselect>
          </b-col>
        </b-row>
        <b-row class="my-4 px-3">
          <b-col class="pt-2" cols="5"> Site #</b-col>
          <b-col cols="7">
            <multiselect
              :disabled="!studyId"
              :options="siteOptions"
              :value="siteId"
              class="rounded-pill"
              placeholder="Select a site"
              @input="updateSite"
            >
            </multiselect>
          </b-col>
        </b-row>
        <hr class="solid" />
      </b-form-group>
    </b-card>
    <b-card class="cardStyle mt-4">
      <div class="title text-center">Requested for:</div>
      <access-request-form
        :radioButtonIsDisabled="radioButtonIsDisabled"
        @onFormUpdate="updateUserDetails"
      />
    </b-card>
    <div class="mt-4">
      <b-button variant="link" @click="redirectBack">Cancel</b-button>
      <b-button
        :disabled="!canSubmitForm"
        :variant="!canSubmitForm ? 'secondary' : 'primary'"
        class="float-right rounded-pill"
        @click="switchToManageRequest"
      >
        Next - Access Manager
      </b-button>
    </div>
  </section>
</template>
<script>
  import AccessRequestForm from './AccessRequestForm';
  import { mapGetters } from 'vuex';

  export default {
    name: 'setup-request',
    components: { AccessRequestForm },
    props: {
      showManageRequest: Boolean,
      siteId: String,
      studyId: String,
      studyOptions: Array,
      studySites: Array,
      accessCase: String,
    },
    data() {
      return {
        firstTime: true,
      };
    },
    created() {
      let study = this.$route.params['studyId'];
      let site = this.$route.params['siteId'];
      if (study !== undefined && site !== undefined) {
        let specificStudySites = this.studySites.find(element => element['studyId'] === study);
        if (specificStudySites !== undefined && specificStudySites['sites'].includes(site)) {
          this.updateStudy(study);
        } else {
          this.$bvModal.show('no-study-site-modal');
        }
      }
    },
    computed: {
      ...mapGetters(['userDetails']),
      siteOptions() {
        if (this.studyId === null) {
          return [];
        } else {
          return this.getSiteOptions();
        }
      },
      radioButtonIsDisabled() {
        return this.studyId === null || this.siteId === null;
      },
      canSubmitForm() {
        return Object.keys(this.userDetails).length > 0 && this.studyId && this.siteId;
      },
    },
    methods: {
      getSiteOptions() {
        let param =
          this.$route.params['studyId'] && this.firstTime ? this.$route.params['siteId'] : null;
        this.updateSite(param);
        this.firstTime = false;
        let studySites = this.studySites.find(element => element['studyId'] === this.studyId);
        return studySites['sites'].sort((a, b) => a.localeCompare(b));
      },
      redirectBack() {
        this.$router.go(-1);
      },
      switchToManageRequest() {
        this.$emit('switchToManageRequest', true);
      },
      updateUserDetails(userInfo) {
        this.$store.commit('setUserDetails', userInfo);
      },
      updateSite(siteId) {
        this.$emit('update:siteId', siteId);
      },
      updateStudy(studyId) {
        this.$emit('update:studyId', studyId);
      },
    },
  };
</script>

<style scoped>
  .title {
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #1c1b1e;
  }

  .subTitle {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.5px;
    color: #006a68;
  }

  .cardStyle {
    background: #fffbfe;
    box-shadow: 0px 4px 4px -2px rgb(23 38 74 / 8%);
    border-radius: 24px;
    letter-spacing: 0.25px;
  }
</style>
